import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from 'src/app/ui/loading/loading.component';

import { RqaTopbarComponent } from './app.topbar';
import { RqaSidebarComponent } from './app.sidebar';
import { RqaFooterComponent } from './app.footer';

@Component({
  selector: 'rqa-layout',
  standalone: true,
  imports: [CommonModule, RqaTopbarComponent, RqaSidebarComponent, RouterModule, RqaFooterComponent, LoadingComponent],
  template: `<div class="layout-wrapper">
    <div class="layout-sidebar-container">
      <rqa-sidebar></rqa-sidebar>
    </div>
    <div class="layout-main-area">
      <rqa-topbar></rqa-topbar>
      <div class="layout-main-content">
        <router-outlet></router-outlet>
        <rqa-footer></rqa-footer>
      </div>
    </div>
    <div class="layout-mask animate-fadein"></div>
    <rqa-loading></rqa-loading>
  </div> `
})
export class RqaLayoutComponent {}
